export default "__VITE_ASSET__CCd6jScT__"